import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { ApiUrls } from "./ApiUrls";
import { MatSnackBar } from "@angular/material/snack-bar";
import { InstallmentConfigurationInitFormResponseModel } from "../model/InstallmentConfigurationInitFormResponseModel";
import { InstallmentConfigurationLotteryInitFormResponseModel } from "../model/InstallmentConfigurationLotteryInitFormResponseModel";
import { InstallmentConfigurationSchemeInitFormResponseModel } from "../model/InstallmentConfigurationSchemeInitFormResponseModel";
import { LotteryInstallmentConfigurationModel } from "../model/LotteryInstallmentConfigurationModel";
import { SchemeInstallmentConfigurationModel } from "../model/SchemeInstallmentConfigurationModel";
import { TenementInsConfigInitFormResponseModel } from "../model/TenementInsConfigInitFormResponseModel";
import { TenementInsConfigFiltersInitFormResponseModel } from "../model/TenementInsConfigFiltersInitFormResponseModel";
import { TenementInsConfigInitFormModel } from "../model/TenementInsConfigInitFormModel";
import { TenementInsConfigInitModel } from "../model/TenementInsConfigInitModel";
import { TenementInsConfigInitWrapperModel } from "../model/TenementInsConfigInitWrapperModel";
import { TenementInstallmentConfigurationModel } from "../model/TenementInstallmentConfigurationModel";
import { InstallmentConfigurationTenementInitEditFormResponseModel } from "../model/InstallmentConfigurationTenementInitEditFormResponseModel";
import { TenementInsConfigDocumentModel } from "../model/TenementInsConfigDocumentModel";
import { RevertWtLstInItWrapper } from "../model/RevertWtLstInItWrapper";
import { Observable } from "rxjs/internal/Observable";
import { ReverseWaitListResponce } from "../model/ReverseWaitListResponce";
import { OprtdAppDtlsResponseModel } from "../model/OprtdAppDtlsResponseModel";

@Injectable({
  providedIn: "root",
})
export class RevertActivatedWaitlistConfigService {
  constructor(private httpClient: HttpClient, private _snackBar: MatSnackBar) {}


  initWithLottery(lotteryKey: number) {
    return this.httpClient.get<InstallmentConfigurationLotteryInitFormResponseModel>(
      ApiUrls.installmentConfigInitWithLotteryUrl.replace(
        "{lotteryKey}",
        lotteryKey.toString()
      )
    );
  }

  initLotteryEventForRevertActdWlt(page: number, size: number, 
    filterText?: string, selectedLottery?: string, selectedScheme?: string){
    let reqParams=
      `?page=${page}&size=${size}`+
      (filterText ? `&filterText=${filterText}` : "") +
      (selectedLottery ? `&selectedLottery=${selectedLottery}` : "") +
      (selectedScheme ? `&selectedScheme=${selectedScheme}` : "");

    return this.httpClient.get<RevertWtLstInItWrapper>(
      ApiUrls.initLotteryEventForRevertActdWlt + reqParams
    );
  }

  getAppDtls(page: number, size: number, lotteryKey: number, schemeKey: number, filterText?: string){
    let reqParams=
      `?page=${page}&size=${size}`+
      (lotteryKey ? `&lotteryKey=${lotteryKey}` : "")+
      (schemeKey ? `&schemeKey=${schemeKey}` : "")+
      (filterText ? `&filterText=${filterText}` : "");

    return this.httpClient.get<RevertWtLstInItWrapper>(
      ApiUrls.getAppDtls + reqParams
    );
  }

  // revertWaitlist(remark: string, file: string | ArrayBuffer, otp: string,
  //   oprtdAppDtls: OprtdAppDtlsResponseModel, applTypeOrWinStage: string, 
  //   applOrWinStageDecision: string, oprtAppKey: number, actdAppKey: number) {
  //   return this.httpClient.post<{status: string, successMsg: string, errorMessage: string}>(
  //     ApiUrls.revertWaitlist, {
  //         oprtAppKey: oprtAppKey,
  //         actdAppKey: actdAppKey,
  //         remark: remark,
  //         wtlstRvrtOrdrFile: file,
  //         otp: otp,
  //         oprtdAppDtls: oprtdAppDtls,
  //         applTypeOrWinStage: applTypeOrWinStage,
  //         applOrWinStageDecision: applOrWinStageDecision,
  //       }
  //   );
  // }

  revertWaitlist(
    remark: string, 
    file: string | ArrayBuffer, 
    otp: string,
    oprtdAppDtls: OprtdAppDtlsResponseModel, 
    applTypeOrWinStage: string, 
    applOrWinStageDecision: string, 
    oprtAppKey: number, 
    actdAppKey: number
  ): Observable<{status: string, successMsg: string, errorMessage: string}> {
    return this.httpClient.post<{status: string, successMsg: string, errorMessage: string}>(
      ApiUrls.revertWaitlist, {
        oprtAppKey: oprtAppKey,
        actdAppKey: actdAppKey,
        remark: remark,
        wtlstRvrtOrdrFile: file,
        otp: otp,
        oprtdAppDtls: oprtdAppDtls,
        applTypeOrWinStage: applTypeOrWinStage,
        applOrWinStageDecision: applOrWinStageDecision,
      }
    );
  }
  

  initScheme(lotteryKey: number) {
    return this.httpClient.get<InstallmentConfigurationLotteryInitFormResponseModel>(
      ApiUrls.installmentConfigInitWithLotteryUrl.replace(
        "{lotteryKey}",
        lotteryKey.toString()
      )
    );
  }

  getDtlsOfOprtdApp(reverseWaitListResponce: ReverseWaitListResponce) {
    return this.httpClient.post<OprtdAppDtlsResponseModel>(
      ApiUrls.getDtlsOfOprtdApp, reverseWaitListResponce
    );
  }

  async successToast(msg) {
    await this._snackBar.open(msg, "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "success-toast",
      duration: 3 * 1000,
    });
  }

  async errorToast(errorMessage: string, dur?: number) {
    await this._snackBar.open(errorMessage, "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "error-toast",
      duration: dur ? dur : 3 * 1000,
    });
  }

  generateOtp(oprtAppNo: string): Observable<object> {
    return this.httpClient.post<Object>(ApiUrls.generateOtpforRvrtWtlst.replace("{oprtAppNo}", oprtAppNo), null);
  }

}
